import { createStitches } from "@stitches/react"

export const {
  styled,
  css,
  globalCss,
  keyframes,
  getCssText,
  theme,
  createTheme,
  config,
} = createStitches({
  theme: {
    colors: {
      background: "#fff",
      header: "#ffffff8c",
      link: "#3E29FF",
      dark: "#14121E",
      border: "#F0F0F0",
      love: "#FF3939",
      textSecondary: "#737373",
      text: "#14121E",
    },
    space: {
      xxs: "3px",
      xs: "7px",
      s: "14px",
      m: "21px",
      l: "35px",
      xl: "56px",
      xxl: "91px",
    },
    shadows: {
      footer: "#c1c1c16b",
    },
    fontSizes: {
      "heading-1": "36px",
      "mobile-heading-1": "26px",
      "heading-2": "24px",
      "body-1": "16px",
      "body-2": "14px",
      "body-3": "12px",
    },
    fonts: {
      space: "Space Grotesk",
      newsreader: "Newsreader",
    },
    fontWeights: {},
    lineHeights: {},
    letterSpacings: {},
    sizes: {},
    borderWidths: {},
    borderStyles: {},
    radii: {
      s: "4px",
      m: "8px",
    },
    zIndices: {},
    transitions: {},
  },
  media: {
    dark: "(prefers-color-scheme: dark)",
    tablet: "(min-width: 768px)",
    desktop: "(min-width: 1024px)",
  },
  utils: {
    mx: (value: string | number) => ({ marginLeft: value, marginRight: value }),
    my: (value: string | number) => ({ marginTop: value, marginBottom: value }),
    mt: (value: string | number) => ({ marginTop: value }),
    mb: (value: string | number) => ({ marginBottom: value }),
    m: (value: string | number) => ({
      marginTop: value,
      marginBottom: value,
      marginLeft: value,
      marginRight: value,
    }),
    pt: (value: string | number) => ({ paddingTop: value }),
    pb: (value: string | number) => ({ paddingBottom: value }),
    px: (value: string | number) => ({
      paddingLeft: value,
      paddingRight: value,
    }),
    py: (value: string | number) => ({
      paddingTop: value,
      paddingBottom: value,
    }),
    p: (value: string | number) => ({
      paddingTop: value,
      paddingBottom: value,
      paddingLeft: value,
      paddingRight: value,
    }),
  },
})

export const darkTheme = createTheme({
  colors: {
    background: "#14121E",
    link: "#9F94FF",
    dark: "#14121E",
    border: "#262626",
    love: "#FF3939",
    textSecondary: "#A1A1A1",
    text: "#fff",
    header: "#14121f8c",
  },
  shadows: {
    footer: "#14121ea6",
  },
})

export const globalStyles = globalCss({
  ":root": {
    fontSize: "62.5%",
    boxSizing: "border-box",
    "-webkit-font-smoothing": "antialiased",
    "text-rendering": "optimizelegibility",
    overflowY: "scroll",
  },
  body: {
    margin: 0,
    fontSize: "1.6rem",
    background: "$background",
    color: "$text",
  },
  em: {
    fontFamily: "newsreader",
  },
  ".active span": {
    fontWeight: "600 !important",
  },
})
